import { HeadType } from 'components/layout/table/head'

export default {
  head: [
    {
      label: null,
      key: 'totalTime',
      col: 8,
      unit: 'h',
      type: HeadType.Highlight,
    },
    {
      label: '= Summe des Zeitbedarfs aller ausgewählten Positionen',
      type: HeadType.Highlight,
      key: 'totalPrice',
      col: 4,
      unit: 'EUR',
    },
  ],
  isAggregation: true,
}
